import React from 'react'

const Folder2Icon = props => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M13.1193 3.06512H8.71929C8.56593 3.06526 8.41406 3.03504 8.27243 2.9762C8.13081 2.91735 8.00224 2.83105 7.89415 2.72226L7.04272 1.87083C6.82882 1.65579 6.57439 1.48531 6.29416 1.36927C6.01392 1.25324 5.71345 1.19394 5.41015 1.19483H2.88043C2.26824 1.19559 1.68134 1.43912 1.24846 1.872C0.815572 2.30489 0.572045 2.89179 0.571289 3.50398V12.496C0.572045 13.1082 0.815572 13.6951 1.24846 14.128C1.68134 14.5608 2.26824 14.8044 2.88043 14.8051H13.1193C13.7315 14.8045 14.3185 14.561 14.7514 14.1281C15.1843 13.6952 15.4278 13.1082 15.4284 12.496V5.37141C15.4272 4.75962 15.1835 4.17327 14.7506 3.74094C14.3177 3.30861 13.7311 3.06557 13.1193 3.06512Z'
        fill='#1F1F1F'
      />
    </svg>
  )
}

export default Folder2Icon
